import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';
import { CustomDateFormatter, CustomNgbDateNativeUTCAdapter } from '@shared/services';

@Component({
  selector: 'lib-form-date',
  styleUrls: ['form-date.component.scss'],
  templateUrl: 'form-date.component.html',
  imports: [FormFieldErrorComponent, FormsModule, NgbInputDatepicker, ReactiveFormsModule, NgClass],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateFormatter },
    { provide: NgbDateAdapter, useClass: CustomNgbDateNativeUTCAdapter },
  ],
})
export class FormDateComponent extends FieldBaseComponent {
  public onDateChange() {
    if (this.config?.onDateChange) {
      this.config.onDateChange();
    }
  }
}
